/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PutCall = {
    P: 'P',
    C: 'C'
} as const;
export type PutCall = typeof PutCall[keyof typeof PutCall];


export function instanceOfPutCall(value: any): boolean {
    for (const key in PutCall) {
        if (Object.prototype.hasOwnProperty.call(PutCall, key)) {
            if (PutCall[key as keyof typeof PutCall] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PutCallFromJSON(json: any): PutCall {
    return PutCallFromJSONTyped(json, false);
}

export function PutCallFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutCall {
    return json as PutCall;
}

export function PutCallToJSON(value?: PutCall | null): any {
    return value as any;
}

export function PutCallToJSONTyped(value: any, ignoreDiscriminator: boolean): PutCall {
    return value as PutCall;
}

